import { useQuery } from "@tanstack/react-query";
import {
  EmissionFactorDTO,
  getEmissionFactors,
  getEmissionFactorsBySite,
  getScientificUnit,
} from "api";
import { QUERY_KEYS } from "consts";

export const useEmissionFactors = () =>
  useQuery<EmissionFactorDTO[]>(
    [QUERY_KEYS.EMISSION_FACTORS],
    getEmissionFactors,
  );

export const useEmissionFactorsBySite = () =>
  useQuery<EmissionFactorDTO[]>(
    [QUERY_KEYS.EMISSION_FACTOR_BY_SITE],
    getEmissionFactorsBySite,
  );

export const useScientificUnit = () =>
  useQuery<any>(
    [QUERY_KEYS.SCIENTIFIC_UNIT],
    getScientificUnit,
  );

